export const BREADCRUMB_IDS = {
    BORROWER: 'borrower',
    INVESTOR: 'investor',
    INVESTMENT_DETAILS: 'investmentDetails',
    LOAN_APPLICATION: 'loan_application',
    LOAN_DETAILS: 'loan_details',
    SOLVENCY_DECLARATION: 'solvency_declaration',
};
